import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MsalProvider } from '@azure/msal-react';
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter
  } from "react-router-dom";
import { msalInstance } from 'msalInstance';
import MuiXLicense from 'utilities/mui-licence';
import PostHogProviderWrapper from 'components/PostHogProvider/PostHogProvider';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <MsalProvider instance={msalInstance}>
            <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
            <PostHogProviderWrapper>
            <MuiXLicense></MuiXLicense>
                <App />
            </PostHogProviderWrapper>
            </BrowserRouter>
            </MsalProvider>
        </ErrorBoundary>
    </React.StrictMode>
);
reportWebVitals();

